import React, { Fragment, useState, useEffect } from "react";
import { Button, Input, Row, Label, Card, CardBody, CustomInput } from "reactstrap";
import { Colxx, Separator } from "../../../../../../components/common/CustomBootstrap";
export default function RequestParam({ settings, saveIntegration }) {
    const [requestParam, setRequestParams] = useState([
        {
            name: '',
            value: ''
        }
    ]);
    useEffect(() => {

        if (settings !== undefined && settings.requestParam !== undefined) {
            console.log(settings.removeParam);
            setRequestParams(settings.requestParam);
        }

    }, [settings]);
    const handleChange = (index, e) => {
        let list = [...requestParam];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];
            obj[e.target.name] = e.target.value;
            list[index] = obj;
        }
        setRequestParams(list);
    }



    const addRequestParam = () => {
        let list = [...requestParam];
        list.push({
            name: '',
            value: ''
        });
        setRequestParams(list);
    }




    const handleSave = (index, e) => {
        saveIntegration({ requestParam: requestParam });
    }



    const removeParam = (index) => {
        let list = [...requestParam];
        list = list.filter((f, i) => index !== i);
        setRequestParams(list);
    }


    return (<Fragment>
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Input Params</h6>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-2 mb-3">
                    <Colxx md="12">
                        <Row>
                            {requestParam !== undefined && requestParam.length > 0 && (
                                <Fragment>
                                    {requestParam.map((m, index) =>
                                        <Fragment>
                                            <Colxx md="12" className="mb-2">
                                                <Row>
                                                    <Colxx md="5" className="mb-2">
                                                        <Input className='input_sty' type="text" name="name" placeholder="{Name}" value={m.name} onChange={(e) => handleChange(index, e)}>
                                                        </Input>
                                                    </Colxx>
                                                    <Colxx md="5" className="mb-2">
                                                        <Input className='input_sty' type="text" name="value" placeholder="Value" value={m.value} onChange={(e) => handleChange(index, e)}>
                                                        </Input>
                                                    </Colxx>
                                                    <Colxx md="2">
                                                        <Button onClick={() => removeParam(index)} className='mt-1' color='danger' size="xs" outline>X</Button>
                                                    </Colxx>
                                                </Row>
                                            </Colxx>
                                        </Fragment>)}
                                </Fragment>
                            )}

                            <Colxx md="12" className="text-left">
                                <Button onClick={addRequestParam} color='primary' size="xs" outline> + Add Param</Button>
                            </Colxx>
                        </Row>
                    </Colxx>
                </div>
                <Separator className="mb-2" />
                <Colxx md="12" className="text-center mb-2">
                    <Button onClick={() => handleSave()} color='primary' size="xs" >Save</Button>
                </Colxx>
            </CardBody>
        </Card >
    </Fragment >);
}